<app-badge>
  <mat-icon>link</mat-icon>
  <span>{{ 'reports.public' | translate }}</span>
  <app-report-share-public-copy-link type="icon"
                                     [link]="link"></app-report-share-public-copy-link>
</app-badge>
